module.exports = __webpack_public_path__ + "media/images/admin/icons/zoom-out-36859c57abf7fa996b6549604a1d8085.svg";